module.exports = __webpack_public_path__ + "2b0f9f0069dfe48121f8e0b879f6039b.pdf";